import axios from '@axios'

export default {
    namespaced: true,
    state: {
        cuentas: [],
        bancos: [],
        cheque: [],
        chequeBanco: [],
        tipos: [],
        operaciones: [],
        codigo: null,
        tempCod: null,
        clientes: [],
        anios: [],
        deudores: [],
        pedidos: [],
        transferencias: [],
        transferenciasOtrosBancos: [],
        proveedor: [],
        transBanco: [],
        AllCuentasBancarias: [],
        empresasOP: [],
        evidenciaOperaciones: [],
        operacionesPorProvisionar: [],
        configContableCuentaBancaria: [],
        contabilidadPreviaCuota: [],
        contabilidadPreviaCuotaInternacional: [],
        generarReporteProvisionesMensuales: [],

        resumidoGeneralSeguimiento: [],
        reporteDetalladoSeguimiento: [],
        vencimientoDetalladoMensualSeguimiento: [],
        cierreModulo: [],
    },
    getters: {
        getCuentas(state) {
            return state.cuentas
        },
        getBancos(state) {
            return state.bancos
        },
        getTipos(state) {
            return state.tipos
        },
        getOperaciones(state) {
            return state.operaciones
        },
        getCodigo(state) {
            return state.codigo
        },
        getTempCodigo(state) {
            return state.tempCod
        },
        getClientes(state) {
            return state.clientes
        },
        getDeudores(state) {
            return state.deudores
        },
        getAnios(state) {
            return state.anios
        },
        getPedidos(state) {
            return state.pedidos
        },

        getDetalleTransferencia(state) {
            return state.transferencias
        },

        getDetalleTransferenciaOtrosBancos(state) {
            return state.transferenciasOtrosBancos
        },

        getProveedor(state) {
            return state.proveedor
        },

        getAgrupadoBancos(state) {
            return state.transBanco
        },
        getDetalleCheques(state) {
            return state.cheque
        },

        getAgrupadoChequesBanco(state) {
            return state.chequeBanco
        },
        getAllCuentasBancarias(state) {
            return state.AllCuentasBancarias
        },
        getEmpresasOP(state) {
            return state.empresasOP
        },
        getEvidenciaOperaciones(state) {
            return state.evidenciaOperaciones
        },
        getOperacionesPorProvisionar(state) {
            return state.operacionesPorProvisionar
        },
        getConfigContableCuentaBancaria(state) {
            return state.configContableCuentaBancaria
        },
        getContabilidadPreviaCuota(state) {
            return state.contabilidadPreviaCuota
        },
        getContabilidadPreviaCuotaInternacional(state) {
            return state.contabilidadPreviaCuotaInternacional
        },
        getGenerarReporteProvisionesMensuales(state) {
            return state.generarReporteProvisionesMensuales
        },
        getResumidoGeneralSeguimiento(state) {
            return state.resumidoGeneralSeguimiento
        },
        getReporteDetalladoSeguimiento(state) {
            return state.reporteDetalladoSeguimiento
        },
        getVencimientoDetalladoMensualSeguimiento(state) {
            return state.vencimientoDetalladoMensualSeguimiento
        },
        getCierreModulo(state) {
            return state.cierreModulo
        },
    },
    mutations: {
        setCuentas(state, cuentas) {
            state.cuentas = cuentas
        },
        setTipos(state, tipos) {
            state.tipos = tipos
        },
        setBancos(state, bancos) {
            state.bancos = bancos
        },
        setOperaciones(state, operaciones) {
            state.operaciones = operaciones
        },
        setCodigo(state, codigo) {
            state.codigo = codigo
        },
        setTempCodigo(state, tempCod) {
            state.tempCod = tempCod
        },
        setClientes(state, clientes) {
            state.clientes = clientes
        },
        setCliente(state, cliente) {
            var c = state.clientes.find(e => e.value === cliente.idcliente)
            if (c) {
                c.text = cliente.cliente
            } else {
                const cl = { value: cliente.idcliente, text: cliente.cliente }
                state.clientes.push(cl)
            }
        },
        setDeudores(state, deudores) {
            state.deudores = deudores
        },
        setDeudor(state, deudor) {
            var d = state.deudores.find(e => e.value === deudor.iddeudor)
            if (d) {
                d.text = deudor.deudor
            } else {
                const de = { value: deudor.iddeudor, text: deudor.deudor }
                state.deudores.push(de)
            }
        },
        setAnios(state, anios) {
            state.anios = anios
        },
        setPedidos(state, pedidos) {
            state.pedidos = pedidos
        },

        setTransferencias(state, transferencias) {
            state.transferencias = transferencias
        },

        setTransferenciasOtrosBancos(state, transferenciasOtrosBancos) {
            state.transferenciasOtrosBancos = transferenciasOtrosBancos
        },
        setProveedor(state, proveedor) {
            state.proveedor = proveedor
        },

        setBanco(state, transBanco) {
            state.transBanco = transBanco
        },

        setCheque(state, cheque) {
            state.cheque = cheque
        },

        setChequeBanco(state, chequeBanco) {
            state.chequeBanco = chequeBanco
        },
        setAllCuentasBancarias(state, AllCuentasBancarias) {
            state.AllCuentasBancarias = AllCuentasBancarias
        },
        setEmpresasOP(state, empresasOP) {
            state.empresasOP = empresasOP
        },
        setEvidenciaOperaciones(state, evidenciaOperaciones) {
            state.evidenciaOperaciones = evidenciaOperaciones
        },
        setOperacionesPorProvisionar(state, operacionesPorProvisionar) {
            state.operacionesPorProvisionar = operacionesPorProvisionar
        },
        setConfigContableCuentaBancaria(state, configContableCuentaBancaria) {
            state.configContableCuentaBancaria = configContableCuentaBancaria
        },
        setContabilidadPreviaCuota(state, contabilidadPreviaCuota) {
            state.contabilidadPreviaCuota = contabilidadPreviaCuota
        },
        setContabilidadPreviaCuotaInternacional(state, contabilidadPreviaCuotaInternacional) {
            state.contabilidadPreviaCuotaInternacional = contabilidadPreviaCuotaInternacional
        },
        setGenerarReporteProvisionesMensuales(state, generarReporteProvisionesMensuales) {
            state.generarReporteProvisionesMensuales = generarReporteProvisionesMensuales
        },
        setResumidoGeneralSeguimiento(state, resumidoGeneralSeguimiento) {
            state.resumidoGeneralSeguimiento = resumidoGeneralSeguimiento
        },
        setReporteDetalladoSeguimiento(state, reporteDetalladoSeguimiento) {
            state.reporteDetalladoSeguimiento = reporteDetalladoSeguimiento
        },
        setVencimientoDetalladoMensualSeguimiento(state, vencimientoDetalladoMensualSeguimiento) {
            state.vencimientoDetalladoMensualSeguimiento = vencimientoDetalladoMensualSeguimiento
        },
        setCierreModulo(state, cierreModulo) {
            state.cierreModulo = cierreModulo
        },
    },
    actions: {
        fetchBancos({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/bancosOperacion')
                    .then(response => {
                        commit('setBancos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTipos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/tiposOperacion', { params: data })
                    .then(response => {
                        commit('setTipos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        enviarAprobacion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/aprobar', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        enviarAnulacion(_, codigo) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/anular', { codigo })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        enviarOperacion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .postForm('/api/auth/financiero/guardarOperacion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        enviarCuentas(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/modificar-cuentas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchOperaciones({ commit, dispatch }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/operaciones', { params: data })
                    .then(response => {
                        commit('setOperaciones', response.data.data)
                        dispatch('fetchCodigo')
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCodigo({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/codigo')
                    .then(response => {
                        commit('setCodigo', response.data)
                        commit('setTempCodigo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchClientes({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/clientes')
                    .then(response => {
                        commit('setClientes', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        enviarCliente({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/crear-cliente', data)
                    .then(response => {
                        commit('setCliente', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchDeudores({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/deudores')
                    .then(response => {
                        commit('setDeudores', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        enviarDeudor({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/crear-deudor', data)
                    .then(response => {
                        commit('setDeudor', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchAnios({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/aniosOpera')
                    .then(response => {
                        commit('setAnios', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchResOpe(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/res-ope', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchResOpeDet(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/res-ope-det', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGarantiasHipotecarias() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/garantias-hipotecarias')
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchVenResBan(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/financiero/ven-res-ban?anio=${data.anio}&cliente=${data.cliente}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchvenResDetBan(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/ven-res-det-ban', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchOpVig(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/financiero/op-vig?cliente=${data.cliente}&banco=${data.banco}&tipo=${data.tipo}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchResDet(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        `/api/auth/financiero/res-det?idcliente=${data.idcliente}&idbanco=${data.idbanco}&tipo=${data.tipo}`
                    )
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        delAmort(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/delAmort', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        reajuste_interes(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/reajuste-interes', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        cargarTabla(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/amort', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        cargarAmort(_, codigo) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/getAmort', { params: { codigo } })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchOrdenes(_, rango) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/ordenes', { params: { ini: rango[0], fin: rango[1] } })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCuentas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/cuentas')
                    .then(response => {
                        commit('setCuentas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchPedidos({ commit }, fecha) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/stockPedidos', fecha)
                    .then(response => {
                        commit('setPedidos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTransferencias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/transferencias', { params: data })
                    .then(response => {
                        commit('setTransferencias', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchTransferenciasOtrosBancos({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/transferenciasOtrosBancos', { params: data })
                    .then(response => {
                        commit('setTransferenciasOtrosBancos', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchProveedor({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/proveedor', { params: data })
                    .then(response => {
                        commit('setProveedor', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchBanco({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/banco', { params: data })
                    .then(response => {
                        commit('setBanco', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postGenerado(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/generado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCheque({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/cheque', { params: data })
                    .then(response => {
                        commit('setCheque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchChequeBanco({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/chequeBanco', { params: data })
                    .then(response => {
                        commit('setChequeBanco', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAllCuentasBancarias({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/all-cuentas-bancarias', { params: data })
                    .then(response => {
                        commit('setAllCuentasBancarias', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEmpresasOP({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/get-empresas-op', { params: data })
                    .then(response => {
                        commit('setEmpresasOP', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        revisarOperacion(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/operacion-revisada', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchEvidenciaOperaciones({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/get-evidencia-op', { params: data })
                    .then(response => {
                        commit('setEvidenciaOperaciones', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchOperacionesPorProvisionar({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/get-operaciones-por-provisionar', { params: data })
                    .then(response => {
                        commit('setOperacionesPorProvisionar', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchConfigContableCuentaBancaria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/config-contable-cuenta-bancaria', { params: data })
                    .then(response => {
                        commit('setConfigContableCuentaBancaria', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postGenerarContabilidadProvisionMensual(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/generar-contabilidad-provision-mensual', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchContabilidadPreviaCuota(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/contabilidad-previa-cuota', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchContabilidadPreviaCuotaInternacional(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/contabilidad-previa-cuota-internacional', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchGenerarReporteProvisionesMensuales(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/generar-reporte-provisiones-mensuales', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /**
         * REPORTERIA DE SEGUIMIENTO DE OPERACIONES
         */

        fetchResumidoGeneralSeguimiento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/resumido-general-seguimiento', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReporteDetalladoSeguimiento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/reporte-detallado-seguimiento', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchVencimientoDetalladoMensualSeguimiento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/vencimiento-detallado-mensual-seguimiento', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchObligacionesVigentesSeguimiento(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/obligaciones-vigentes-seguimiento', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchCierreModulo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/financiero/cierre-modulo', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        postCierreModulo(_, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/financiero/cierre-modulo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
